import { APP_SETTINGS_DATA, APP_SETTINGS_LOADED, APP_SETTINGS_ERROR } from "../reducers/appSettingsReducer";

export const getAppSettingsData = (url, params) => (dispatch) => {
	fetch(`${url}?${new URLSearchParams(params).toString()}`)
		.then(response => response.json())
		.then(data => {
			if (data._code === 200) {
				dispatch({ type: APP_SETTINGS_DATA, payload: data._data });
				dispatch({ type: APP_SETTINGS_LOADED, payload: true });
			} else {
				throw new Error(`(code ${data._code}), ${data._msg}`);
			}
		})
		.catch(err => {
			dispatch({ type: APP_SETTINGS_ERROR, payload: err.message });
		});
}